export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Профиль",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
